var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('font-awesome-icon',_vm._g({staticClass:"ml-1",attrs:{"icon":"file-export"}},on))]}}])},[_c('div',[_vm._v("This module uses explicit exports:")]),_c('pre',[_vm._v("module.exports = {};")])])}
var staticRenderFns = []

export { render, staticRenderFns }